import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircle2Icon, StarIcon, ShieldCheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { FadeIn } from './FadeIn';
const carouselImages = ['https://cdn.magicpatterns.com/uploads/e6AjMF4fTvMMsCMn5pk147/Captura_de_pantalla_2026-03-15_a_la(s)_16.18.52_(1)_(1).webp', 'https://cdn.magicpatterns.com/uploads/f3xE5DM58Um97Z9bCRb6LX/Captura_de_pantalla_2026-03-15_a_la(s)_16.19.31_(1).webp', 'https://cdn.magicpatterns.com/uploads/azxEKJ3uztM6dp45ceu4KJ/Captura_de_pantalla_2026-03-15_a_la(s)_16.20.05_(1).webp', 'https://cdn.magicpatterns.com/uploads/fbVqdpAtzX88RvQjFeAAY4/Captura_de_pantalla_2026-03-15_a_la(s)_16.21.30_(1).webp', 'https://cdn.magicpatterns.com/uploads/9JMmVLUH8yW9ogYMUymf7G/Captura_de_pantalla_2026-03-15_a_la(s)_16.22.26_(1).webp', 'https://cdn.magicpatterns.com/uploads/sYjHi2UStrYiutLWEN2dYR/Captura_de_pantalla_2026-03-15_a_la(s)_16.25.21_(1).webp', 'https://cdn.magicpatterns.com/uploads/92FWyx3vSBFWTpejJnARxh/Captura_de_pantalla_2026-03-15_a_la(s)_16.26.54_(1).webp'];
export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const nextSlide = useCallback(() => {
    setCurrentSlide(prev => (prev + 1) % carouselImages.length);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentSlide(prev => (prev - 1 + carouselImages.length) % carouselImages.length);
  }, []);
  // Auto-advance every 3.5 seconds, pause on hover
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(nextSlide, 3500);
    return () => clearInterval(timer);
  }, [isHovered, nextSlide]);
  return <section className="pt-14 pb-8 md:pt-32 md:pb-20 px-4 overflow-hidden relative bg-gradient-to-b from-white to-gray-50/50" data-id="element-156">
      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-157">
        <FadeIn className="w-full flex flex-col items-center" data-id="element-158">
          <div className="inline-flex items-center gap-1 bg-gradient-to-r from-kid-yellow/20 to-kid-orange/20 px-4 py-1.5 rounded-full shadow-sm border border-kid-yellow/30 mb-5 md:mb-8" data-id="element-159">
            <div className="flex text-kid-yellow" data-id="element-160">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-161" />)}
            </div>
            <span className="text-xs md:text-sm font-medium text-gray-600 ml-2 tracking-wide" data-id="element-162">
              Padres Satisfechos
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-4 md:mb-6 text-balance max-w-3xl tracking-tight" data-id="element-163">
            <span className="block mb-1 md:mb-2" data-id="element-164">
              El problema no es tu hijo.
            </span>
            <span className="block bg-gradient-to-r from-kid-purple to-kid-pink bg-clip-text text-transparent" data-id="element-165">
              Es el orden en que le enseñan a leer.
            </span>
          </h1>

          <div className="text-base md:text-lg text-gray-600 mb-5 md:mb-6 leading-relaxed max-w-2xl mx-auto font-normal" data-id="element-166">
            <p className="mb-1.5 md:mb-2" data-id="element-167">
              Descubrí la{' '}
              <span className="underline decoration-gray-300 underline-offset-4" data-id="element-168">
                secuencia correcta de aprendizaje
              </span>
            </p>
            <p className="text-2xl md:text-3xl font-semibold my-3 md:my-4 text-gray-800" data-id="element-169">
              <span className="text-kid-purple" data-id="element-170">sonido</span>{' '}
              <span className="text-gray-400 mx-1 md:mx-2" data-id="element-171">→</span>{' '}
              <span className="text-kid-pink" data-id="element-172">trazo</span>{' '}
              <span className="text-gray-400 mx-1 md:mx-2" data-id="element-173">→</span>{' '}
              <span className="text-kid-sky" data-id="element-174">palabra</span>
            </p>
            <p data-id="element-175">
              que transforma la frustración en{' '}
              <span className="font-semibold text-gray-900" data-id="element-176">
                avances reales
              </span>{' '}
              y ayuda a tu hijo a iniciar la lectura con más seguridad,
              dedicando{' '}
              <span className="font-semibold text-kid-purple bg-kid-purple/10 px-2 py-0.5 rounded-md" data-id="element-177">
                solo 10 minutos por día.
              </span>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="w-full flex flex-col items-center" data-id="element-178">
          <ul className="space-y-2.5 md:space-y-3 mb-6 md:mb-10 max-w-md mx-auto w-full" data-id="element-179">
            {[{
            text: 'Método guiado paso a paso',
            color: 'text-kid-lime',
            bg: 'bg-kid-lime/10',
            border: 'border-kid-lime/20'
          }, {
            text: 'Material imprimible listo para usar',
            color: 'text-kid-sky',
            bg: 'bg-kid-sky/10',
            border: 'border-kid-sky/20'
          }, {
            text: 'Diseñado para niños de 3 a 7 años',
            color: 'text-kid-purple',
            bg: 'bg-kid-purple/10',
            border: 'border-kid-purple/20'
          }, {
            text: 'Aplicable desde casa sin ser docente',
            color: 'text-kid-orange',
            bg: 'bg-kid-orange/10',
            border: 'border-kid-orange/20'
          }].map((item, idx) => <li key={idx} className={`flex items-center gap-3 text-gray-700 font-medium text-sm md:text-base p-2.5 md:p-3 rounded-xl ${item.bg} border ${item.border}`} data-id="element-180">
                <CheckCircle2Icon className={`w-5 h-5 ${item.color} flex-shrink-0`} data-id="element-181" />
                <span className="text-left" data-id="element-182">{item.text}</span>
              </li>)}
          </ul>
        </FadeIn>

        {/* Image Carousel Section */}
        <FadeIn delay={0.3} className="w-full mb-6 md:mb-10" data-id="element-183">
          <p className="text-lg md:text-xl font-semibold text-gray-800 mb-4" data-id="element-184">
            Acá te doy un vistazo a nuestro sistema 👇🏻
          </p>
          <div className="relative w-full max-w-lg mx-auto rounded-2xl overflow-hidden shadow-lg border border-gray-200" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-185">
            {/* Images */}
            <div className="relative aspect-[4/3] bg-white" data-id="element-186">
              {carouselImages.map((src, idx) => <img key={idx} src={src} alt={`Ejemplo del sistema - ${idx + 1}`} className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-500 ease-in-out ${idx === currentSlide ? 'opacity-100' : 'opacity-0'}`} data-id="element-187" />)}
            </div>

            {/* Navigation arrows */}
            <button onClick={e => {
            e.stopPropagation();
            prevSlide();
          }} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center hover:bg-white transition-colors z-10 border border-gray-100" aria-label="Anterior" data-id="element-188">
              <ChevronLeftIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-700" data-id="element-189" />
            </button>
            <button onClick={e => {
            e.stopPropagation();
            nextSlide();
          }} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center hover:bg-white transition-colors z-10 border border-gray-100" aria-label="Siguiente" data-id="element-190">
              <ChevronRightIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-700" data-id="element-191" />
            </button>

            {/* Dot indicators */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-10" data-id="element-192">
              {carouselImages.map((_, idx) => <button key={idx} onClick={() => setCurrentSlide(idx)} className={`rounded-full transition-all duration-300 ${idx === currentSlide ? 'w-6 h-2 bg-kid-purple' : 'w-2 h-2 bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-193" />)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="w-full flex flex-col items-center" data-id="element-194">
          <div className="flex flex-col items-center gap-3 md:gap-4 w-full max-w-md" data-id="element-195">
            <CTAButton text="QUIERO EL SISTEMA DE LECTURA »" size="xl" className="w-full" animatePulse={true} data-id="element-196" />
            <div className="flex flex-wrap items-center justify-center gap-2 text-xs md:text-sm text-gray-500 font-medium" data-id="element-197">
              <ShieldCheckIcon className="w-4 h-4 text-kid-lime" data-id="element-198" />
              <span data-id="element-199">Acceso inmediato</span>
              <span className="text-gray-300" data-id="element-200">·</span>
              <span data-id="element-201">Pago único</span>
              <span className="text-gray-300" data-id="element-202">·</span>
              <span data-id="element-203">Material digital descargable</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}